import { render } from "./MigrationPrepStep.vue?vue&type=template&id=41a9f495"
import script from "./MigrationPrepStep.vue?vue&type=script&lang=ts"
export * from "./MigrationPrepStep.vue?vue&type=script&lang=ts"
script.render = render

export default script